import { useEffect, useState } from "react";
import Style from "./SecondInputForm.module.css";

// styles
import "../../../index.css";

//my components
import AttachAdditionalDocumentation from "../../InputComponents/AttachAdditionalDocumentation/AttachAdditionalDocumentation";
import AttachCurrentlyAvailableBudget from "../../InputComponents/AttachCurrentlyAvailableBudget/AttachCurrentlyAvailableBudget";
import AttachHeadOfDepartmentStatement from "../../InputComponents/AttachHeadOfDepartmentStatement/AttachHeadOfDepartmentStatement";
import DropdownDepartmentsInput from "../../InputComponents/DropdownDepartmentsInput/DropdownDepartmentsInput";
import DropdownMenuInputOther from "../../InputComponents/DropdownMenuInputOther/DropdownMenuInputOther";
import FormLabel from "../../InputComponents/FormLabel/FormLabel";
import GenerateHeadOfDepartmentStatement from "../../InputComponents/GenerateHeadOfDepartmentStatement/GenerateHeadOfDepartmentStatement";
import ModalMessage from "../../InputComponents/ModalMessage/ModalMessage";
import NumberInput from "../../InputComponents/NumberInput/NumberInput";
import NumberInputSelect from "../../InputComponents/NumberInputSelect/NumberInputSelect";
import ProjectSummary from "../../InputComponents/ProjectSummary/ProjectSummary";
import Question from "../../InputComponents/Question/Question";
import RadioButtonInput from "../../InputComponents/RadioButtonInput/RadioButtonInput";
import SpecialInputForm from "../../InputComponents/SpecialInputForm/SpecialInputForm";
import TextInput from "../../InputComponents/TextInput/TextInput";
// data
import {
  projectTypesData,
  sourceOfFundingData,
} from "../../../constants/dropdownMenuData";
import {
  secondFormQuestions as questions,
  radioButtonData1,
} from "../../../constants/formQuestions";

// get dean api
import { getDean } from "../../PageComponents/AdminDashboard/AdminDashboardComponents/ModalSettings/deanApi";

// utils
import getAuthHeader from "../../../utils/getAuthHeader";
import { clearAllKeysFromStorageStartingWith } from "../../../utils/localStorage";
import { roundToTwoDecimals } from "../../../utils/numbers";
import translateMissingFields from "../../../utils/translateMissingFields";

// context
import { useNavigate } from "react-router-dom";
import { PROJECT_STATE } from "../../../constants/projectStates";
import { SecondInputFormDataContext } from "../../../context/SecondInputFormDataContext";
import { useAuthContext } from "../../../hooks/useAuthContext";
import CalendarInputAdvanced from "../../InputComponents/CalendarInputAdvanced/CalendarInputAdvanced";
import ModalApplicationUpdated from "../../InputComponents/ModalApplicationUpdated/ModalApplicationUpdated";
import NewEmploymentPositions from "../../InputComponents/NewEmploymentPositions/NewEmploymentPositions";
import SpecialInputProjectPartnerExpensesContainer from "../../InputComponents/SpecialInputForm/SpecialInputProjectPartnersExpensesContainer/SpecialInputProjectPartnersExpensesContainer";
import TotalExpenseWarning from "../../InputComponents/TotalExpenseWarning/TotalExpenseWarning";

const SecondInputForm = ({ docId }) => {
  const { user } = useAuthContext();
  const [intentionFormToUpdate, setIntentionFormToUpdate] = useState(null);
  const [nameSurname, setNameSurname] = useState(null);
  const [vocation, setVocation] = useState(null);
  const [departmentId, setDepartmentId] = useState("");
  const [department, setDepartment] = useState("");
  // fetched departments
  const [departmentsData, setDepartmentsData] = useState([]);
  const [email, setEmail] = useState(null);
  const [mobilePhoneNumber, setMobilePhoneNumber] = useState(null);
  const [workTimeThisPercentage, setWorkTimeThisPercentage] = useState(null);
  const [workTimeOtherPercentage, setWorkTimeOtherPercentage] = useState(null);
  const [teamLeaderNote, setTeamLeaderNote] = useState(null);
  const [projectTitle, setProjectTitle] = useState(null);
  const [projectTitleEnglish, setProjectTitleEnglish] = useState(null);
  const [projectAcronym, setProjectAcronym] = useState(null);
  const [applicationDeadline, setApplicationDeadline] = useState(null);
  const [projectSummary, setProjectSummary] = useState(null);
  const [applicationURL, setApplicationURL] = useState(null);
  const [sourceOfFunding, setSourceOfFunding] = useState(null);
  const [projectType, setProjectType] = useState(null);
  const [expectedProjectBeginning, setExpectedProjectBeginning] =
    useState(null);
  const [expectedProjectDurationInMonths, setExpectedProjectDurationInMonths] =
    useState(null);
  const [projectApplicant, setProjectAplicant] = useState(null);
  const [projectPartners, setProjectPartners] = useState(null);
  const [economicSubjectInvolvement, setEconomicSubjectInvolvement] =
    useState(null);
  const [totalValue, setTotalValue] = useState(null);
  const [fesbValuePart, setFesbValuePart] = useState(null);
  const [calculatedFesbValuePart, setCalculatedFesbValuePart] = useState(0);
  const [calculatedSumString, setCalculatedSumString] = useState("");
  const [currentPersonnelExpense, setCurrentPersonnelExpense] = useState(null);
  const [newPersonnelExpense, setNewPersonnelExpense] = useState(null);
  const [indirectExpenses, setIndirectExpenses] = useState(null);
  const [indirectExpensesManualInput, setIndirectExpensesManualInput] =
    useState(null);
  const [equipmentDescriptionAndExpense, setEquipmentDescriptionAndExpense] =
    useState(0);
  const [equipmentAmortizationExpense, setEquipmentAmortizationExpense] =
    useState(0);
  const [otherServicesExpense, setOtherServicesExpense] = useState(null);
  const [materialExpense, setMaterialExpense] = useState(null);
  const [
    travelRegistrationEducationExpense,
    setTravelRegistrationEducationExpense,
  ] = useState(null);
  const [expenseNote, setExpenseNote] = useState(null);
  const [partnerExpense, setPartnerExpense] = useState(null);
  const [downPayment, setDownPayment] = useState(null);
  const [personalFinancingExpense, setPersonalFinancingExpense] =
    useState(null);
  const [newEmploymentBoolean, setNewEmploymentBoolean] = useState(null);
  const [newEmploymentPositions, setNewEmploymentPositions] = useState(null);
  const [projectTeam, setProjectTeam] = useState(null);
  const [consultantServices, setConsultantServices] = useState(null);
  const [consultantExpense, setConsultantExpense] = useState(0);
  const [consultantExpenseSource, setConsultantExpenseSource] = useState(null);
  const [requiredDocumentationFESB, setRequiredDocumentationFESB] =
    useState(null);
  const [pdfDocuments, setPdfDocuments] = useState([]);
  const [equipmentStorageLocation, setEquipmentStorageLocation] =
    useState(null);
  const [newEmploymentsWorkspace, setNewEmploymentsWorkspace] = useState(null);
  const [isNewEquipmentOrdering, setIsNewEquipmentOrdering] = useState(null);

  // application updated modal - after application is submitted
  const [modalApplicationUpdatedIsOpen, setModalApplicationUpdatedIsOpen] =
    useState(false);

  // empty fields modal
  const [modalMessageIsOpen, setModalMessageIsOpen] = useState(false);
  const [missingFields, setMissingFields] = useState([]);

  // this component is used to calculate total expense
  const [totalExpense, setTotalExpense] = useState(0);

  const [deanData, setDeanData] = useState(null);
  const [partnersList, setPartnersList] = useState(() => {
    try {
      const storedData = localStorage.getItem(`partnersList-${docId}`);
      return storedData ? JSON.parse(storedData) : [];
    } catch (error) {
      console.error("Error parsing partnersList from localStorage:", error);
      return [];
    }
  });

  const [equipmentsExpenses, setEquipmentsExpenses] = useState(() => {
    try {
      const storedData = localStorage.getItem(`equipmentsExpenses-${docId}`);
      return storedData ? JSON.parse(storedData) : [];
    } catch (error) {
      console.error(
        "Error parsing equipmentsExpenses from localStorage:",
        error
      );
      return [];
    }
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [draftSaved, setDraftSaved] = useState(false);
  const [draftSaving, setDraftSaving] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseProjectInfo = await fetch(`/api/projectInfo/${docId}`, {
          headers: getAuthHeader(),
        });

        if (!responseProjectInfo.ok) {
          throw new Error(`HTTP error! Status: ${responseProjectInfo.status}`);
        }

        const data = await responseProjectInfo.json();
        if (data.state === PROJECT_STATE.projectRejected) navigate(-1);

        setIntentionFormToUpdate(data);
        if (data?.projectPartnersExpenses.length > 0) {
          setPartnersList(data.projectPartnersExpenses);
        }

        const responseDepartments = await fetch("/api/department");
        if (!responseDepartments.ok) {
          console.error("Failed to fetch department data");
          throw new Error("Failed to fetch department data");
        }

        const departments = await responseDepartments.json();
        const fetchedDepartments = departments.map((department) => {
          return {
            fullName: department.name + " - " + department.headName,
            id: department.id,
          };
        });

        setDepartmentsData(fetchedDepartments);

        const initialDepartment = fetchedDepartments.find(
          (department) => department.id === data?.departmentId
        );
        setDepartment(initialDepartment);
        setDepartmentId(initialDepartment.id);
      } catch (error) {
        console.error("Error during data:", error);
        throw new Error("Error during data");
      }
    };
    fetchData();

    const fetchDeanData = async () => {
      try {
        const deanData = await getDean();
        setDeanData(deanData[0]);
      } catch (error) {
        console.error("Error fetching dean data", error);
        window.alert("Greška u dohvaćanju podataka o dekanu!");
      }
    };

    fetchDeanData();
  }, [docId]);

  useEffect(() => {
    setNameSurname(intentionFormToUpdate?.nameSurname);
    setVocation(intentionFormToUpdate?.vocation);
    setEmail(intentionFormToUpdate?.email);
    setProjectTitle(intentionFormToUpdate?.projectTitle);
    setProjectTitleEnglish(intentionFormToUpdate?.projectTitleEnglish);
    setProjectAcronym(intentionFormToUpdate?.projectAcronym);
    setApplicationDeadline(intentionFormToUpdate?.applicationDeadline);
    setProjectSummary(intentionFormToUpdate?.projectSummary);
    setApplicationURL(intentionFormToUpdate?.applicationURL);
    setProjectAplicant(intentionFormToUpdate?.projectApplicant);
    setProjectPartners(intentionFormToUpdate?.projectPartners);
    setTotalValue(intentionFormToUpdate?.totalValue);
    setFesbValuePart(intentionFormToUpdate?.fesbValuePart);
    setNewEmploymentBoolean(intentionFormToUpdate?.newEmploymentBoolean);
    setNewEmploymentPositions(intentionFormToUpdate?.newEmploymentPositions);
    setProjectTeam(intentionFormToUpdate?.projectTeam);
    if (intentionFormToUpdate?.equipmentsExpenses) {
      setEquipmentsExpenses(intentionFormToUpdate?.equipmentsExpenses);
    }
    // If this is a draft, load all the additional fields
    if (intentionFormToUpdate?.state === "draft") {
      // Load all fields from saved draft
      setMobilePhoneNumber(intentionFormToUpdate.mobilePhoneNumber);
      setWorkTimeThisPercentage(intentionFormToUpdate.workTimeThisPercentage);
      setWorkTimeOtherPercentage(intentionFormToUpdate.workTimeOtherPercentage);
      setTeamLeaderNote(intentionFormToUpdate.teamLeaderNote);
      setSourceOfFunding(intentionFormToUpdate.sourceOfFunding);
      setProjectType(intentionFormToUpdate.projectType);
      setExpectedProjectBeginning(
        intentionFormToUpdate.expectedProjectBeginning
      );
      setExpectedProjectDurationInMonths(
        intentionFormToUpdate.expectedProjectDurationInMonths
      );
      setEconomicSubjectInvolvement(
        intentionFormToUpdate.economicSubjectInvolvement
      );
      setCurrentPersonnelExpense(intentionFormToUpdate.currentPersonnelExpense);
      setNewPersonnelExpense(intentionFormToUpdate.newPersonnelExpense);
      setIndirectExpenses(intentionFormToUpdate.indirectExpenses);
      setIndirectExpensesManualInput(
        intentionFormToUpdate.indirectExpensesManualInput
      );
      setEquipmentDescriptionAndExpense(
        intentionFormToUpdate.equipmentDescriptionAndExpense || 0
      );
      setEquipmentAmortizationExpense(
        intentionFormToUpdate.equipmentAmortizationExpense || 0
      );

      // Set the correct equipment ordering radio button
      if (intentionFormToUpdate.equipmentDescriptionAndExpense > 0) {
        setIsNewEquipmentOrdering(true);
      } else if (intentionFormToUpdate.equipmentAmortizationExpense > 0) {
        setIsNewEquipmentOrdering(false);
      } else {
        setIsNewEquipmentOrdering(null);
      }

      setEquipmentStorageLocation(
        intentionFormToUpdate.equipmentStorageLocation
      );
      setOtherServicesExpense(intentionFormToUpdate.otherServicesExpense);
      setMaterialExpense(intentionFormToUpdate.materialExpense);
      setTravelRegistrationEducationExpense(
        intentionFormToUpdate.travelRegistrationEducationExpense
      );
      setExpenseNote(intentionFormToUpdate.expenseNote);
      setPartnerExpense(intentionFormToUpdate.partnerExpense);
      setDownPayment(intentionFormToUpdate.downPayment);
      setPersonalFinancingExpense(
        intentionFormToUpdate.personalFinancingExpense
      );
      setNewEmploymentsWorkspace(intentionFormToUpdate.newEmploymentsWorkspace);
      setConsultantServices(intentionFormToUpdate.consultantServices);
      setConsultantExpense(intentionFormToUpdate.consultantExpense);
      setConsultantExpenseSource(intentionFormToUpdate.consultantExpenseSource);
      setRequiredDocumentationFESB(
        intentionFormToUpdate.requiredDocumentationFESB
      );
    }
  }, [intentionFormToUpdate, department]);

  useEffect(() => {
    setIndirectExpenses(0.15 * (currentPersonnelExpense + newPersonnelExpense));
  }, [currentPersonnelExpense, newPersonnelExpense]);

  useEffect(() => {
    const calculatedIndirectExpenses =
      0.15 * (currentPersonnelExpense + newPersonnelExpense);

    if (indirectExpenses !== calculatedIndirectExpenses) {
      setIndirectExpensesManualInput(true);
    } else if (indirectExpenses === calculatedIndirectExpenses) {
      setIndirectExpensesManualInput(false);
    }
  }, [indirectExpenses, currentPersonnelExpense, newPersonnelExpense]);

  const checkNaN = (value) => {
    if (isNaN(value)) return 0;
    return value;
  };

  useEffect(() => {
    if (isNewEquipmentOrdering) {
      setEquipmentAmortizationExpense(0);
    } else {
      setEquipmentDescriptionAndExpense(0);
    }
  }, [isNewEquipmentOrdering]);

  useEffect(() => {
    const totalFesbValuePart =
      Number(checkNaN(currentPersonnelExpense)) +
      Number(checkNaN(newPersonnelExpense)) +
      Number(checkNaN(indirectExpenses)) +
      Number(checkNaN(equipmentDescriptionAndExpense)) +
      Number(checkNaN(equipmentAmortizationExpense)) +
      Number(checkNaN(otherServicesExpense)) +
      Number(checkNaN(materialExpense)) +
      Number(checkNaN(travelRegistrationEducationExpense));

    setCalculatedFesbValuePart(totalFesbValuePart);

    setCalculatedSumString(
      `(${currentPersonnelExpense ?? 0} + ${newPersonnelExpense ?? 0} + ${
        roundToTwoDecimals(indirectExpenses) ?? 0
      } + ${
        isNewEquipmentOrdering
          ? equipmentDescriptionAndExpense
          : equipmentAmortizationExpense
      } + ${otherServicesExpense ?? 0} + ${materialExpense ?? 0} + ${
        travelRegistrationEducationExpense ?? 0
      }) EUR ${totalFesbValuePart !== fesbValuePart ? " ≠ " : " = "} ${
        fesbValuePart ?? 0
      } EUR`
    );

    const calculatedTotalExpense =
      totalFesbValuePart + Number(checkNaN(partnerExpense));

    setTotalExpense(calculatedTotalExpense);
  }, [
    partnerExpense,
    currentPersonnelExpense,
    newPersonnelExpense,
    indirectExpenses,
    fesbValuePart,
    equipmentDescriptionAndExpense,
    equipmentAmortizationExpense,
    otherServicesExpense,
    materialExpense,
    travelRegistrationEducationExpense,
  ]);

  const [totalFileCount, setTotalFileCount] = useState(0);
  const MAX_FILES_ALLOWED = 10;

  const handleFilesSelect = (selectedFiles, componentKey) => {
    setPdfDocuments((prevDocuments) => {
      const fileMap = new Map();

      prevDocuments.forEach((file) => {
        if (file.componentKey && file.componentKey !== componentKey) {
          if (!fileMap.has(file.componentKey)) {
            fileMap.set(file.componentKey, []);
          }
          fileMap.get(file.componentKey).push(file);
        }
      });

      const newFiles = selectedFiles.map((file) => ({
        file,
        name: file.name,
        size: file.size,
        type: file.type,
        componentKey,
      }));

      fileMap.set(componentKey, newFiles);
      const allFiles = Array.from(fileMap.values()).flat();

      setTotalFileCount(allFiles.length);

      return allFiles;
    });
  };

  useEffect(() => {
    localStorage.setItem(
      `equipmentsExpenses-${docId}`,
      JSON.stringify(equipmentsExpenses)
    );
  }, [equipmentsExpenses]);

  useEffect(() => {
    localStorage.setItem(`partnersList-${docId}`, JSON.stringify(partnersList));
  }, [partnersList]);

  const getDataForSubmit = (isDraftSave = false) => {
    return {
      userId: user?.userId,
      secondInputMarker: true,
      nameSurname,
      vocation,
      departmentId,
      email,
      projectTitle,
      projectTitleEnglish,
      projectAcronym,
      applicationDeadline,
      projectSummary,
      applicationURL,
      projectApplicant,
      projectPartners,
      totalValue,
      fesbValuePart,
      newEmploymentBoolean,
      newEmploymentsWorkspace:
        !isDraftSave && !newEmploymentBoolean
          ? "nema"
          : newEmploymentsWorkspace,
      projectTeam,
      mobilePhoneNumber,
      workTimeThisPercentage,
      workTimeOtherPercentage,
      teamLeaderNote: !teamLeaderNote && !isDraftSave ? "nema" : teamLeaderNote,
      sourceOfFunding,
      projectType,
      expectedProjectBeginning,
      expectedProjectDurationInMonths,
      economicSubjectInvolvement,
      currentPersonnelExpense,
      newPersonnelExpense,
      indirectExpenses,
      indirectExpensesManualInput,
      equipmentDescriptionAndExpense,
      equipmentAmortizationExpense,
      equipmentStorageLocation,
      equipmentsExpenses,
      projectPartnersExpenses: JSON.stringify(partnersList),
      otherServicesExpense,
      materialExpense,
      travelRegistrationEducationExpense,
      expenseNote: !expenseNote && !isDraftSave ? "nema" : expenseNote,
      partnerExpense,
      downPayment: !downPayment && !isDraftSave ? 0 : downPayment,
      personalFinancingExpense,
      newEmploymentPositions,
      consultantServices,
      consultantExpense:
        !consultantExpense && !isDraftSave ? 0 : consultantExpense,
      consultantExpenseSource:
        !consultantExpenseSource && !isDraftSave
          ? "nema"
          : consultantExpenseSource,
      requiredDocumentationFESB,
    };
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    setIsSubmitted(true);
    const cleanData = getDataForSubmit();

    pdfDocuments?.forEach((fileObj) => {
      if (fileObj.file instanceof File) {
        formData.append("pdfDocuments", fileObj.file);
      } else if (fileObj instanceof File) {
        formData.append("pdfDocuments", fileObj);
      }
    });

    Object.entries(cleanData).forEach(([key, value]) => {
      if (key === "equipmentsExpenses") {
        formData.append(
          "equipmentsExpenses",
          JSON.stringify(equipmentsExpenses)
        );
      } else if (key === "projectTeam") {
        formData.append("projectTeam", JSON.stringify(projectTeam));
      } else if (key === "newEmploymentPositions") {
        formData.append(
          "newEmploymentPositions",
          JSON.stringify(newEmploymentPositions)
        );
      } else if (key !== "pdfDocuments") {
        formData.append(key, value);
      }
    });
    try {
      const response = await fetch(`/api/projectInfo/${docId}`, {
        method: "PATCH",
        headers: {
          ...getAuthHeader(),
        },
        body: formData,
      });

      /*  const partnersExpenses = partnersList.map((partner) => {
        return {
          name: partner.name,
          budget: parseFloat(partner.budget),
          projectinfosId: docId,
        };
      });

     if (!partnersExpenses || partnersExpenses.length > 0) {
        const responsePartners = await fetch(`/api/projectPartnersExpenses/`, {
          method: "POST",
          body: JSON.stringify(partnersExpenses),
          headers: {
            ...getAuthHeader(),
            "Content-Type": "application/json",
          },
        }).catch((error) => {
          console.error("Error posting partners expenses: ", error);
          window.alert("Greška u slanju troškova partnera!");
        });

        if (responsePartners.ok) {
          clearAllKeysFromStorageStartingWith("partnersList");
        }
      } */

      if (response.ok) {
        await response.json();
        setModalApplicationUpdatedIsOpen(true);
        clearAllKeysFromStorageStartingWith("partnersList");
        clearAllKeysFromStorageStartingWith("equipmentsExpenses");
        clearAllKeysFromStorageStartingWith("metadata");
        sessionStorage.clear();
        // Clear PDF documents after successful submission
        setPdfDocuments([]);
        setTotalFileCount(0);
      } else {
        const errorData = await response.json().catch(() => null);

        if (
          errorData &&
          errorData.emptyFields &&
          errorData.emptyFields.length > 0
        ) {
          const missingFieldsMessage = `Missing fields: ${errorData.emptyFields.join(
            ", "
          )}`;
          console.error(missingFieldsMessage);

          setMissingFields(errorData.emptyFields);
          setModalMessageIsOpen(true);
        } else {
          window.alert(`Greška u slanju podataka!`);
        }
      }
    } catch (error) {
      window.alert(`Greška u slanju podataka: ${error.message}`);
    }
  };

  // Add a function to save the form as draft
  const handleSaveDraft = async () => {
    setDraftSaving(true);
    const formData = new FormData();

    const formDataToSave = getDataForSubmit(true);

    pdfDocuments?.forEach((fileObj) => {
      if (fileObj.file instanceof File) {
        formData.append("pdfDocuments", fileObj.file);
      } else if (fileObj instanceof File) {
        formData.append("pdfDocuments", fileObj);
      }
    });

    Object.entries(formDataToSave).forEach(([key, value]) => {
      if (key === "equipmentsExpenses") {
        formData.append(
          "equipmentsExpenses",
          JSON.stringify(equipmentsExpenses)
        );
      } else if (key === "projectTeam") {
        formData.append("projectTeam", JSON.stringify(projectTeam));
      } else if (key === "newEmploymentPositions") {
        formData.append(
          "newEmploymentPositions",
          JSON.stringify(newEmploymentPositions)
        );
      } else if (
        key !== "pdfDocuments" &&
        value !== null &&
        value !== undefined
      ) {
        formData.append(key, value);
      }
    });

    try {
      const response = await fetch(`/api/projectInfo/${docId}/draft`, {
        method: "PATCH",
        headers: {
          ...getAuthHeader(),
        },
        body: formData,
      });

      if (response.ok) {
        setDraftSaved(true);
        setTimeout(() => setDraftSaved(false), 3000);
      } else {
        window.alert("Greška u spremanju skice");
      }
    } catch (error) {
      console.error("Error saving draft:", error);
      window.alert(`Greška u spremanju skice: ${error.message}`);
    } finally {
      setDraftSaving(false);
    }
  };

  return (
    <div className={Style.InputFormContainer}>
      <div className={Style.InputForm}>
        <SecondInputFormDataContext.Provider
          value={{
            projectTeam,
            projectAcronym,
            setProjectTeam,
            totalValue,
            departmentId,
            nameSurname,
            projectTitle,
            setModalApplicationUpdatedIsOpen,
            totalExpense,
            fesbValuePart,
            calculatedFesbValuePart,
            newEmploymentPositions,
            setNewEmploymentPositions,
            deanData,
            vocation,
            equipmentStorageLocation,
            newEmploymentsWorkspace,
          }}
        >
          {modalMessageIsOpen && (
            <ModalMessage
              modalMessage={translateMissingFields(missingFields)}
              height={"15em"}
              setModalIsOpen={setModalMessageIsOpen}
              isMissingFieldsModal={true}
              fontSizeProp={"auto"}
            />
          )}
          {modalApplicationUpdatedIsOpen && <ModalApplicationUpdated />}
          <h1 className="document-title">TRAŽENJE SUGLASNOSTI</h1>
          <Question questionText={questions[0]} />
          <div className={Style.NameSurnameContainer}>
            <label className={Style.NameSurnameLabel}>IME I PREZIME</label>
            <p className={Style.NameSurnameData}>{user.fullName}</p>
          </div>
          <TextInput
            label={"TITULA*"}
            name={"vocation_2"}
            setSpecificState={setVocation}
            initialValue={vocation}
            isError={isSubmitted && !vocation}
            isInFirstInput={true}
          />
          <DropdownDepartmentsInput
            label={"ZAVOD (ODSJEK)*"}
            name={"department_2"}
            data={departmentsData}
            setSpecificState={setDepartmentId}
            isDepartment={true}
            initialValue={department?.fullName}
            isError={isSubmitted && !departmentId}
            isInFirstInput={true}
          />
          <TextInput
            label={"E-MAIL"}
            name={"email_2"}
            setSpecificState={setEmail}
            initialValue={email}
            type={"email"}
            isError={isSubmitted && !email}
            isInFirstInput={true}
            isDisabled={true}
          />
          <TextInput
            label={"MOBITEL**"}
            name={"phone_number_2"}
            setSpecificState={setMobilePhoneNumber}
            initialValue={mobilePhoneNumber}
            isError={isSubmitted && !mobilePhoneNumber}
          />
          <NumberInput
            currencySign={"%"}
            label={"POSTOTAK U PROJEKTU**"}
            name={"work_time_this_percentage"}
            setSpecificState={setWorkTimeThisPercentage}
            initialValue={workTimeThisPercentage}
            isError={isSubmitted && workTimeThisPercentage === null}
          />
          <TextInput
            label={
              "OSTALI PROJEKTI NA KOJIMA RADI PRIJAVITELJ PROJEKTA I U KOJEM POSTOTKU**"
            }
            name={"work_time_other_percentage"}
            setSpecificState={setWorkTimeOtherPercentage}
            initialValue={workTimeOtherPercentage}
            isError={isSubmitted && !workTimeOtherPercentage}
          />
          <TextInput
            label={"NAPOMENA"}
            name={"team_leader_disclamer"}
            setSpecificState={setTeamLeaderNote}
            initialValue={teamLeaderNote}
          />
          <Question questionText={questions[1]} />
          <TextInput
            label={"NAZIV PROJEKTA*"}
            name={"project_title"}
            setSpecificState={setProjectTitle}
            initialValue={projectTitle}
            isError={isSubmitted && !projectTitle}
            isInFirstInput={true}
          />
          <TextInput
            label={"NAZIV PROJEKTA NA ENGLESKOM JEZIKU**"}
            name={"project_title_en"}
            setSpecificState={setProjectTitleEnglish}
            initialValue={projectTitleEnglish}
            isError={isSubmitted && !projectTitleEnglish}
            isInFirstInput={true}
          />
          <TextInput
            label={"AKRONIM PROJEKTA*"}
            name={"project_acronym_2"}
            setSpecificState={setProjectAcronym}
            initialValue={projectAcronym}
            isError={isSubmitted && !projectAcronym}
            isInFirstInput={true}
          />
          <CalendarInputAdvanced
            label={"ROK ZA PRIJAVU PROJEKTA*"}
            name={"application_dead_line"}
            setSpecificState={setApplicationDeadline}
            initialDate={applicationDeadline}
            isSecondInputForm={true}
            isInFirstInput={true}
            workingDaysLimit={3}
            isError={isSubmitted && !applicationDeadline}
          />
          <Question questionText={questions[2]} />
          <ProjectSummary
            name={"project_summary"}
            initialValue={projectSummary}
            setSpecificState={setProjectSummary}
            isError={isSubmitted && !projectSummary}
            isSecondInputForm={true}
          />
          <Question questionText={questions[3]} />
          <TextInput
            label={
              "LINK NA INTERNETSKU STRANICU NA KOJOJ SE NALAZI POTPUNA DOKUMENTACIJA S TEKSTOM NATJEČAJA*"
            }
            name={"application_url"}
            setSpecificState={setApplicationURL}
            initialValue={applicationURL}
            isError={isSubmitted && !applicationURL}
            isInFirstInput={true}
          />
          <Question questionText={questions[4]} />
          <DropdownMenuInputOther
            label={""}
            name={"source_of_funding"}
            data={sourceOfFundingData}
            setSpecificState={setSourceOfFunding}
            isError={isSubmitted && !sourceOfFunding}
            defaultValue={sourceOfFunding}
          />
          <Question questionText={questions[5]} />
          <DropdownMenuInputOther
            label={""}
            name={"type_of_projects"}
            data={projectTypesData}
            setSpecificState={setProjectType}
            isError={isSubmitted && !projectType}
            defaultValue={projectType}
          />
          <Question questionText={questions[6]} />
          <CalendarInputAdvanced
            label={"POČETAK PROJEKTA**"}
            name={"expected_project_beginning"}
            setSpecificState={setExpectedProjectBeginning}
            initialDate={expectedProjectBeginning}
            isSecondInputForm={true}
            workingDaysLimit={10}
            isError={isSubmitted && !expectedProjectBeginning}
          />
          <Question questionText={questions[7]} />
          <NumberInput
            name={"expected_project_duration_in_months"}
            setSpecificState={setExpectedProjectDurationInMonths}
            currencySign={""}
            initialValue={expectedProjectDurationInMonths}
            isError={isSubmitted && expectedProjectDurationInMonths === null}
          />
          <Question questionText={questions[8]} />
          <TextInput
            label={
              "PRIJAVITELJ PROJEKTA/VODEĆI PARTNER (INSTITUCIJA, TVRTKA, ...)*"
            }
            name={"project_applicant"}
            setSpecificState={setProjectAplicant}
            initialValue={projectApplicant}
            isError={isSubmitted && !projectApplicant}
            isInFirstInput={true}
          />
          <Question questionText={questions[9]} />
          <TextInput
            name={"project_partners"}
            setSpecificState={setProjectPartners}
            initialValue={projectPartners}
            hasTitle={false}
            isError={isSubmitted && !projectPartners}
            isInFirstInput={true}
          />
          <Question questionText={questions[10]} />
          <RadioButtonInput
            name={"economic_subjet_involvment"}
            simpleQuestionValue={radioButtonData1}
            setSelectionState={setEconomicSubjectInvolvement}
            isError={isSubmitted && economicSubjectInvolvement === null}
            initialValue={economicSubjectInvolvement ?? undefined}
          />
          <Question questionText={questions[11]} />
          <NumberInput
            label={""}
            name={"total_value"}
            setSpecificState={setTotalValue}
            initialValue={totalValue}
            currencySign={"EUR"}
            isError={isSubmitted && totalValue === null}
            isInFirstInput={true}
          />
          <Question questionText={questions[12]} />
          <NumberInputSelect
            label={"DIO PRORAČUNA KOJI PRIPADA FESB-u*"}
            name={"fesb_value_part"}
            setSpecificState={setFesbValuePart}
            initialValue={fesbValuePart}
            isSecondInputForm={true}
            isFirstInputForm={false}
            isInFirstInput={true}
            isError={isSubmitted && fesbValuePart === null}
          />
          <NumberInput
            label={"TROŠAK POSTOJEĆEG OSOBLJA**"}
            name={"current_personnel_expense"}
            setSpecificState={setCurrentPersonnelExpense}
            isSecondInputForm={true}
            isFirstInputForm={false}
            currencySign={"EUR"}
            initialValue={currentPersonnelExpense}
            isError={isSubmitted && currentPersonnelExpense === null}
          />
          <NumberInput
            label={"TROŠAK NOVOZAPOSLENOG OSOBLJA**"}
            name={"new_personnel_expense"}
            setSpecificState={setNewPersonnelExpense}
            isSecondInputForm={true}
            isFirstInputForm={false}
            currencySign={"EUR"}
            initialValue={newPersonnelExpense}
            isError={isSubmitted && newPersonnelExpense === null}
          />
          <NumberInput
            label={"NEIZRAVNI TROŠKOVI (15% NA TROŠKOVE OSOBLJA)"}
            name={"indirect_expenses"}
            setSpecificState={setIndirectExpenses}
            isSecondInputForm={true}
            isFirstInputForm={false}
            currencySign={"EUR"}
            initialValue={indirectExpenses}
            isError={isSubmitted && indirectExpenses === null}
          />
          {indirectExpensesManualInput && <p>Neizravni troškovi izmjenjeni!</p>}

          <FormLabel label={"NABAVLJA LI SE OPREMA ILI SE AMORTIZIRA?**"} />
          <RadioButtonInput
            labelYes={"TROŠAK OPREME KOJA SE NABAVLJA "}
            labelNo={"TROŠAK AMORTIZACIJE OPREME"}
            setSelectionState={setIsNewEquipmentOrdering}
            initialValue={isNewEquipmentOrdering ?? true}
          />
          {isNewEquipmentOrdering !== null && (
            <>
              {isNewEquipmentOrdering && (
                <NumberInputSelect
                  label={
                    "TROŠAK OPREME KOJA SE NABAVLJA (NABAVA IZNAD 26.544,00 EUR ĆE BITI OZNAČENA)"
                  }
                  name={"equipment_description_and_expense"}
                  setSpecificState={setEquipmentDescriptionAndExpense}
                  isSecondInputForm={true}
                  isFirstInputForm={false}
                  isError={
                    isSubmitted && equipmentDescriptionAndExpense === null
                  }
                  initialValue={equipmentDescriptionAndExpense}
                />
              )}
              {equipmentDescriptionAndExpense > 26544 && (
                <p>
                  <span>⚠</span>
                  <span className={Style.noteText}>
                    {" "}
                    Nabava je iznad 26.544,00 EUR
                  </span>
                </p>
              )}
              {!isNewEquipmentOrdering && (
                <NumberInputSelect
                  label={"TROŠAK AMORTIZACIJE OPREME"}
                  name={"equipment_amortization_expense"}
                  setSpecificState={setEquipmentAmortizationExpense}
                  isSecondInputForm={true}
                  isFirstInputForm={false}
                  isError={isSubmitted && equipmentAmortizationExpense === null}
                  initialValue={equipmentAmortizationExpense}
                />
              )}
            </>
          )}
          {isNewEquipmentOrdering !== null && (
            <SpecialInputProjectPartnerExpensesContainer
              setPartnersList={setEquipmentsExpenses}
              partnersList={equipmentsExpenses}
              partnerExpense={
                isNewEquipmentOrdering
                  ? equipmentDescriptionAndExpense
                  : equipmentAmortizationExpense
              }
              label={"OPREMA (NAZIV I CIJENA)"}
            />
          )}
          <TextInput
            label={"PROSTOR GDJE ĆE SE OPREMA SMJESTITI**"}
            name={"equipment_storage_location"}
            setSpecificState={setEquipmentStorageLocation}
            isFirstInputForm={false}
            isSecondInputForm={true}
            initialValue={equipmentStorageLocation}
            isError={isSubmitted && !equipmentStorageLocation}
          />
          <NumberInputSelect
            label={"TROŠAK VANJSKIH USLUGA**"}
            name={"other_services_expense"}
            setSpecificState={setOtherServicesExpense}
            isSecondInputForm={true}
            isFirstInputForm={false}
            initialValue={otherServicesExpense}
            isError={isSubmitted && otherServicesExpense === null}
          />
          <NumberInputSelect
            label={"TROŠAK MATERIJALA I SITNOG INVENTARA**"}
            name={"material_expense"}
            setSpecificState={setMaterialExpense}
            isSecondInputForm={true}
            isFirstInputForm={false}
            initialValue={materialExpense}
            isError={isSubmitted && materialExpense === null}
          />
          <NumberInputSelect
            label={"PUTNI TROŠAK/TROŠAK KOTIZACIJA/STRUČNOG USAVRŠAVANJA**"}
            name={"travel_registration_education_expense"}
            setSpecificState={setTravelRegistrationEducationExpense}
            isSecondInputForm={true}
            isFirstInputForm={false}
            initialValue={travelRegistrationEducationExpense}
            isError={isSubmitted && travelRegistrationEducationExpense === null}
          />
          <div>
            <p style={{ fontWeight: "bold" }}>Provjera sume: </p>
            <p className={Style.noteText}>{calculatedSumString}</p>
            <p className={Style.noteText}>
              {calculatedFesbValuePart} EUR{" "}
              {calculatedFesbValuePart !== fesbValuePart ? "≠" : "="}{" "}
              {fesbValuePart} EUR
            </p>
            {calculatedFesbValuePart < fesbValuePart && (
              <p>
                <span>⚠</span>
                <span className={Style.noteText}>
                  {" "}
                  Zbroj troškova je manji od prethodno navedenog FESB proračuna.
                </span>
              </p>
            )}
          </div>
          <TotalExpenseWarning />
          <TextInput
            label={
              "NAPOMENA (Navedite ostale kategorije troška, ukoliko nešto prethodno nije navedeno)"
            }
            name={"expense_note"}
            setSpecificState={setExpenseNote}
            initialValue={expenseNote}
          />
          <Question questionText={questions[13]} />
          <NumberInputSelect
            label={"UKUPNI PRORAČUN OSTALIH PARTNERA**"}
            name={"partner_expense"}
            setSpecificState={setPartnerExpense}
            isSecondInputForm={true}
            isFirstInputForm={false}
            isError={isSubmitted && partnerExpense === null}
            initialValue={partnerExpense}
          />
          <TotalExpenseWarning hideFESBValueWarning={true} />
          <SpecialInputProjectPartnerExpensesContainer
            setPartnersList={setPartnersList}
            partnersList={partnersList}
            partnerExpense={partnerExpense}
          />
          <Question questionText={questions[14]} />
          <NumberInputSelect
            label={""}
            name={"down_payment"}
            setSpecificState={setDownPayment}
            isSecondInputForm={true}
            isFirstInputForm={false}
            isError={isSubmitted && downPayment === null}
            initialValue={downPayment}
          />
          <Question questionText={questions[15]} />
          <p className={Style.noteText}>
            Ukoliko projekt nije 100% financiran, kako planirate sufinancirati
            nefinancirani dio?
          </p>
          <TextInput
            name={"personal_financing_expense"}
            setSpecificState={setPersonalFinancingExpense}
            hasTitle={false}
            isError={isSubmitted && !personalFinancingExpense}
            initialValue={personalFinancingExpense}
          />
          <Question questionText={questions[16]} />
          <RadioButtonInput
            name={"new_employment_boolean"}
            setSelectionState={setNewEmploymentBoolean}
            initialValue={newEmploymentBoolean}
            isError={isSubmitted && newEmploymentBoolean === null}
          />
          {newEmploymentBoolean && (
            <TextInput
              label={"PROSTORIJA ZA SMJEŠTAJ NOVOZAPOSLENIH"}
              name={"new_employments_workspace"}
              setSpecificState={setNewEmploymentsWorkspace}
              isError={isSubmitted && !newEmploymentsWorkspace}
              initialValue={newEmploymentsWorkspace}
            />
          )}
          {newEmploymentBoolean && <NewEmploymentPositions formType="second" />}
          <Question questionText={questions[17]} />
          <SpecialInputForm
            name="project_team_members"
            questionText={""}
            formType={"second"}
          />
          <Question questionText={questions[18]} />
          <RadioButtonInput
            name={"consultant_services"}
            setSelectionState={setConsultantServices}
            isError={isSubmitted && consultantServices === null}
            initialValue={consultantServices}
          />
          {consultantServices && (
            <div>
              <p>Ukoliko je odgovor DA:</p>
              <NumberInput
                label={"TROŠAK KONZULTANTSKE USLUGE"}
                name={"consultant_expense"}
                setSpecificState={setConsultantExpense}
                initialValue={consultantExpense}
                currencySign={"EUR"}
                isError={isSubmitted && consultantExpense === null}
              />
              <TextInput
                label={"IZVOR SREDSTAVA ZA KONZULTANTSKE USLUGE"}
                name={"consultant_expense_source"}
                setSpecificState={setConsultantExpenseSource}
                isError={isSubmitted && !consultantExpenseSource}
                initialValue={consultantExpenseSource}
              />
            </div>
          )}
          <Question questionText={questions[19]} />
          <p className={Style.noteText}>
            Naznačite u kakvom obliku je potrebna dokumentacija (elektronski,
            preslika,ovjerena preslika, izvornik, i sl.)
          </p>
          <TextInput
            name={"required_documentation_FESB"}
            setSpecificState={setRequiredDocumentationFESB}
            hasTitle={false}
            isError={isSubmitted && !requiredDocumentationFESB}
            initialValue={requiredDocumentationFESB}
          />
          <GenerateHeadOfDepartmentStatement department={department} />
          <Question questionText={questions[20]} />
          <AttachHeadOfDepartmentStatement
            onFilesSelect={handleFilesSelect}
            totalFiles={totalFileCount}
            maxFiles={MAX_FILES_ALLOWED}
          />
          <AttachCurrentlyAvailableBudget
            onFilesSelect={handleFilesSelect}
            totalFiles={totalFileCount}
            maxFiles={MAX_FILES_ALLOWED}
          />
          <AttachAdditionalDocumentation
            onFilesSelect={handleFilesSelect}
            totalFiles={totalFileCount}
            maxFiles={MAX_FILES_ALLOWED}
          />
          <div className={Style.pdfHeaderContainer}>
            <p className={Style.fileCounter}>
              Moguće je odabrati do maksimalno 10 dokumenata.
            </p>
            <p className={Style.fileCounter}>
              Učitali ste: {totalFileCount}/{MAX_FILES_ALLOWED} dokumenata
            </p>
          </div>

          <div className={Style.buttonsContainer}>
            <button
              className="default-button secondary-button"
              onClick={handleSaveDraft}
              disabled={draftSaving}
            >
              {draftSaving ? "SPREMANJE..." : "SPREMI KAO DRAFT"}
            </button>
            <button className="default-button" onClick={handleSubmit}>
              PODNESI TRAŽENJE SUGLASNOSTI
            </button>
          </div>

          {draftSaved && (
            <div className={Style.draftSavedMessage}>
              Draft uspješno spremljen
            </div>
          )}
        </SecondInputFormDataContext.Provider>
      </div>
    </div>
  );
};
export default SecondInputForm;
